/* eslint-disable arrow-body-style */
/* eslint-disable no-console */
import mixpanel from 'mixpanel-browser';
import getCookie from '../utils/getCookie';

export default function useTrack(eventTitle, data) {
  try {
    // Check if mixpanel is properly initialized
    // eslint-disable-next-line no-underscore-dangle
    if (!mixpanel || !mixpanel.__loaded) {
      console.warn('Mixpanel not loaded yet, skipping event:', eventTitle);
      return;
    }

    const distinctId = getCookie('mixid');

    if (distinctId) {
      mixpanel.register({ distinct_id: `${distinctId}` });
    }

    if (data) {
      return distinctId ? mixpanel.track(eventTitle, { ...data, 'Distinct ID': distinctId }) : mixpanel.track(eventTitle, data);
    }

    return mixpanel.track(eventTitle);
  } catch (error) {
    console.warn('Error tracking event:', error);
    return null;
  }
}
